module.exports = __webpack_public_path__ + "static/media/Edit.75932cf2.svg";